<template>
  <v-card :raised="true">
    <div>
      <div v-if="r && r.ActiveFlag">
        <div style="float: left; width: 110px; text-align: center">
          <v-avatar class="mt-5" size="89">
            <v-img :src="referralSourcePhoto" />
          </v-avatar>
        </div>

        <div style="padding-left: 110px">
          <v-card-title v-if="windowWidth > 350"
            >{{ r.FirstName }} {{ r.LastName }}</v-card-title
          >
          <v-card-title v-else
            >{{ r.FirstName }} <br />
            {{ r.LastName }}</v-card-title
          >
          <v-card-subtitle v-if="r.Title && getLanguage() == 1"
            >{{ r.Title }}
            <span v-if="r.ReferralSourceLic" class="ml-2">
              - {{ r.ReferralSourceLic }}</span
            >
          </v-card-subtitle>
          <v-card-subtitle v-if="r.TitleFr && getLanguage() == 2"
            >{{ r.TitleFr }}
            <span v-if="r.ReferralSourceLic" class="ml-2">
              - {{ r.ReferralSourceLic }}</span
            >
          </v-card-subtitle>
          <v-card-text v-if="r.Desc && getLanguage() == 1"
            ><div v-html="formattedReferralDesc"></div
          ></v-card-text>
            <v-card-text v-if="r.DescFr && getLanguage() == 2"
            ><div v-html="formattedReferralDescFr"></div
          ></v-card-text>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div v-if="r.WorkPhone">
                  <b>{{ $t("labels.Phone") }}:</b>
                  {{ r.WorkPhone }}
                </div>
                <div v-if="r.Mobile">
                  <b>{{ $t("labels.Mobile") }}:</b>
                  {{ r.Mobile }}
                </div>
                <div v-if="r.FAX">
                  <b>{{ $t("labels.FAX") }}:</b>
                  {{ r.FAX }}
                </div>
              </v-col>
              <v-col cols="12">
                <div v-if="r.Email">
                  <v-icon size="15" class="mr-2">far fa-envelope</v-icon>
                  <a :href="'mailto:' + r.Email">{{ r.Email }}</a>
                </div>
                <div v-if="r.Web">
                  <v-icon size="15" class="mr-2">fas fa-globe</v-icon>
                  <a target="_blank" :href="getURL(r.Web)">{{ r.Web }}</a>
                </div>
                <div v-if="r.FaceBook">
                  <v-icon size="15" class="mr-2">fab fa-facebook</v-icon>
                  <a target="_blank" :href="getURL(r.FaceBook)">{{
                    r.FaceBook
                  }}</a>
                </div>
                <div v-if="r.Instagram">
                  <v-icon size="15" class="mr-2">fab fa-instagram</v-icon>
                  <a target="_blank" :href="getURL(r.Instagram)">{{
                    r.Instagram
                  }}</a>
                </div>
                <div v-if="r.Twitter">
                  <v-icon size="15" class="mr-2">fab fa-twitter</v-icon>
                  <a target="_blank" :href="getURL(r.Twitter)">{{
                    r.Twitter
                  }}</a>
                </div>
                <div v-if="r.Linkedin">
                  <v-icon size="15" class="mr-2">fab fa-linkedin</v-icon>
                  <a target="_blank" :href="getURL(r.Linkedin)">{{
                    r.Linkedin
                  }}</a>
                </div>
              </v-col>
            </v-row>
            <img
              v-if="referralSourceLogo"
              :src="referralSourceLogo"
              width="150"
            />
            <div v-text="r.ReferralSourceCompanyName" />
            <div v-text="r.BrokerageLic" />
          </v-card-text>
        </div>
        <v-divider />
      </div>

      <div v-if="a && a.ActiveFlag">
        <div style="float: left; width: 110px; text-align: center">
          <v-avatar class="mt-5" size="99">
            <v-img :src="agentPhoto" />
          </v-avatar>
        </div>
        <div style="padding-left: 110px">
          <v-card-title v-if="windowWidth > 350"
            >{{ a.FirstName }} {{ a.LastName }}</v-card-title
          >
          <v-card-title v-else
            >{{ a.FirstName }} <br />
            {{ a.LastName }}</v-card-title
          >
          <v-card-subtitle v-if="getLanguage() == 1"
            >{{ a.Title }}
            <span v-if="a.AgentLic" class="ml-2">
              - {{ a.AgentLic }}</span
            ></v-card-subtitle
          >
           <v-card-subtitle v-if="getLanguage() == 2"
            >{{ a.TitleFr }}
            <span v-if="a.AgentLic" class="ml-2">
              - {{ a.AgentLic }}</span
            ></v-card-subtitle
          >
          <v-card-text v-if="a.Desc && getLanguage() == 1"
            ><div v-html="formattedAgentDesc"></div
          ></v-card-text>

           <v-card-text v-if="a.DescFr && getLanguage() == 2"
            ><div v-html="formattedAgentDescFr"></div
          ></v-card-text>

          <v-divider />

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div v-if="a.WorkPhone">
                  <b>{{ $t("labels.Phone") }}:</b> {{ a.WorkPhone }}
                </div>
                <div v-if="a.Mobile">
                  <b>{{ $t("labels.Mobile") }}:</b> {{ a.Mobile }}
                </div>
                <div v-if="a.FAX">
                  <b>{{ $t("labels.FAX") }}:</b> {{ a.FAX }}
                </div>
              </v-col>
              <v-col cols="12">
                <div v-if="a.Email">
                  <v-icon size="15" class="mr-2">far fa-envelope</v-icon>
                  <a :href="'mailto:' + a.Email">{{ a.Email }}</a>
                </div>
                <div v-if="a.Web">
                  <v-icon size="15" class="mr-2">fas fa-globe</v-icon>
                  <a target="_blank" :href="getURL(a.Web)">{{ a.Web }}</a>
                </div>
                <div v-if="a.FaceBook">
                  <v-icon size="15" class="mr-2">fab fa-facebook</v-icon>
                  <a target="_blank" :href="getURL(a.FaceBook)">{{
                    a.FaceBook
                  }}</a>
                </div>
                <div v-if="a.Instagram">
                  <v-icon size="15" class="mr-2">fab fa-instagram</v-icon>
                  <a target="_blank" :href="getURL(a.Instagram)">{{
                    a.Instagram
                  }}</a>
                </div>
                <div v-if="a.Twitter">
                  <v-icon size="15" class="mr-2">fab fa-twitter</v-icon>
                  <a target="_blank" :href="getURL(a.Twitter)">{{
                    a.Twitter
                  }}</a>
                </div>
                <div v-if="a.Linkedin">
                  <v-icon size="15" class="mr-2">fab fa-linkedin</v-icon>
                  <a target="_blank" :href="getURL(a.Linkedin)">{{
                    a.Linkedin
                  }}</a>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <img v-if="agentLogo" :src="agentLogo" width="99" />
            <div v-text="a.BrokerageName" />
            <div v-text="a.BrokerageLic" />
          </v-card-text>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import domainHelper from "@/services/domainHelper";
import localStorageSvc from "@/services/localStorage";
export default {
  props: ["pd"],
  data() {
    return {
      windowWidth: window.innerWidth,
      lan: 1,
    };
  },
  methods: {
    getURL(u) {
      return u.indexOf("://") === -1 ? "http://" + u : u;
    },
    getLanguage() {
      let lan = localStorageSvc.getLan();
      if (lan == "fr" || lan == "FR") {
        return 2;
      } else {
        return 1;
      }
    },
  },
  computed: {
    r() {
      let rv = null;
      try {
        rv = this.pd.ReferralSourceProfile;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    a() {
      let rv = null;
      try {
        rv = this.pd.AgentProfile;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    formattedReferralDesc() {
      return this.pd.ReferralSourceProfile.Desc.replace(/\n/g, "<br>") // Convert newlines to <br> tags
        .replace(/\*(.*?)\*/g, "<strong>$1</strong>") // Example: Convert *text* to bold
        .replace(/_(.*?)_/g, "<em>$1</em>");
    },
    formattedAgentDesc() {
      return this.pd.AgentProfile.Desc.replace(/\n/g, "<br>") // Convert newlines to <br> tags
        .replace(/\*(.*?)\*/g, "<strong>$1</strong>") // Example: Convert *text* to bold
        .replace(/_(.*?)_/g, "<em>$1</em>");
    },
     formattedReferralDescFr() {
      return this.pd.ReferralSourceProfile.DescFr.replace(/\n/g, "<br>") // Convert newlines to <br> tags
        .replace(/\*(.*?)\*/g, "<strong>$1</strong>") // Example: Convert *text* to bold
        .replace(/_(.*?)_/g, "<em>$1</em>");
    },
    formattedAgentDescFr() {
      return this.pd.AgentProfile.DescFr.replace(/\n/g, "<br>") // Convert newlines to <br> tags
        .replace(/\*(.*?)\*/g, "<strong>$1</strong>") // Example: Convert *text* to bold
        .replace(/_(.*?)_/g, "<em>$1</em>");
    },
    referralSourcePhoto() {
      let rv = null;
      try {
        if (this.pd.ReferralSourceProfile.ReferralSourcePhoto)
          rv =
            domainHelper.getAPIHost() +
            "/ws/ReferralPhoto/" +
            this.pd.ReferralSourceProfile.ReferralSourcePhoto;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    referralSourceLogo() {
      let rv = null;
      try {
        if (this.r.ReferralSourceCompanyLogo)
          rv =
            domainHelper.getAPIHost() +
            "/ws/ReferralLogo/" +
            this.r.ReferralSourceCompanyLogo;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentPhoto() {
      let rv = null;
      try {
        if (this.a.AgentPhoto)
          rv =
            domainHelper.getAPIHost() +
            "/ws/AgentProfilePhoto/" +
            this.a.AgentPhoto;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
    agentLogo() {
      let rv = null;
      try {
        if (this.a.BrokerageLogo)
          rv =
            domainHelper.getAPIHost() +
            "/ws/BrokerageLogo/" +
            this.a.BrokerageLogo;
      } catch (err) {
        rv = null;
      }
      return rv;
    },
  },
  created() {},
};
</script>

<style>
</style>